import { render, staticRenderFns } from "./AppointmentStatusModal.vue?vue&type=template&id=115fbcbf&"
import script from "./AppointmentStatusModal.vue?vue&type=script&lang=js&"
export * from "./AppointmentStatusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports